import { z } from 'zod';

import { AccordionWidgetStaticSchema } from './AccordionWidgetStaticSchema';
import { AudioWidgetStaticSchema } from './AudioWidgetStaticSchema';
import { BlockTitleWidgetStaticSchema } from './BlockTitleWidgetStaticSchema';
import { CardSectionWidgetStaticSchema } from './CardSectionWidgetStaticSchema';
import { CardWidgetStaticSchema } from './CardWidgetStaticSchema';
import { CarouselWidgetStaticSchema } from './CarouselWidgetStaticSchema';
import { ClozeQuestionWidgetStaticSchema } from './ClozeQuestionWidgetStaticSchema';
import { CombinedTitleWidgetStaticSchema } from './CombinedTitleWidgetStaticSchema';
import { ContentAreaWidgetStaticSchema } from './ContentAreaWidgetStaticSchema';
import { EmbedWidgetStaticSchema } from './EmbedWidgetStaticSchema';
import { EnclosureWithBlockTitleWidgetStaticSchema } from './EnclosureWithBlockTitleWidgetStaticSchema';
import { EnclosureWithCombinedTitleWidgetStaticSchema } from './EnclosureWithCombinedTitleWidgetStaticSchema';
import { EvaluatablePluginWidgetStaticSchema } from './EvaluatablePluginWidgetStaticSchema';
import { FillInTheBlanksQuestionWidgetStaticSchema } from './FillInTheBlanksQuestionWidgetStaticSchema';
import { FlexSectionWidgetStaticSchema } from './FlexSectionWidgetStaticSchema';
import { GeogebraQuestionWidgetStaticSchema } from './GeogebraQuestionWidgetStaticSchema';
import { GeogebraWidgetStaticSchema } from './GeogebraWidgetStaticSchema';
import { HotspotQuestionWidgetStaticSchema } from './HotspotQuestionWidgetStaticSchema';
import { HotspotWidgetStaticSchema } from './HotspotWidgetStaticSchema';
import { ImageWidgetStaticSchema } from './ImageWidgetStaticSchema';
import { InteractivePollWidgetStaticSchema } from './InteractivePollWidgetStaticSchema';
import { InteractiveQuizWidgetStaticSchema } from './InteractiveQuizWidgetStaticSchema';
import { InteractiveVideoWidgetStaticSchema } from './InteractiveVideoWidgetStaticSchema';
import { MicrosoftEmbedWidgetStaticSchema } from './MicrosoftEmbedWidgetStaticSchema';
import { OpenDiscussionWidgetStaticSchema } from './OpenDiscussionWidgetStaticSchema';
import { OpenQuestionWidgetStaticSchema } from './OpenQuestionWidgetStaticSchema';
import { PageWidgetStaticSchema } from './PageWidgetStaticSchema';
import { PdfDocumentWidgetStaticSchema } from './PdfDocumentWidgetStaticSchema';
import { PluginWidgetStaticSchema } from './PluginWidgetStaticSchema';
import { QuestionGroupListWidgetStaticSchema } from './QuestionGroupListWidgetStaticSchema';
import { SectionWidgetStaticSchema } from './SectionWidgetStaticSchema';
import { SelectionQuestionWidgetStaticSchema } from './SelectionQuestionWidgetStaticSchema';
import { SlideWidgetStaticSchema } from './SlideWidgetStaticSchema';
import { SortQuestionWidgetStaticSchema } from './SortQuestionWidgetStaticSchema';
import { SpacerWidgetStaticSchema } from './SpacerWidgetStaticSchema';
import { StyledBulletListWidgetStaticSchema } from './StyledBulletListWidgetStaticSchema';
import { TableWidgetStaticSchema } from './TableWidgetStaticSchema';
import { TextWidgetStaticSchema } from './TextWidgetStaticSchema';
import { UnifiedVideoStaticSchema } from './UnifiedVideoWidgetStaticSchema';
import { VideoWidgetStaticSchema } from './VideoWidgetStaticSchema';
import { YesNoQuestionWidgetStaticSchema } from './YesNoQuestionWidgetStaticSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const staticSchemas = {
  Accordion: AccordionWidgetStaticSchema,
  Audio: AudioWidgetStaticSchema,
  BlockTitle: BlockTitleWidgetStaticSchema,
  Card: CardWidgetStaticSchema,
  CardSection: CardSectionWidgetStaticSchema,
  Carousel: CarouselWidgetStaticSchema,
  ClozeQuestion: ClozeQuestionWidgetStaticSchema,
  CombinedTitle: CombinedTitleWidgetStaticSchema,
  ContentArea: ContentAreaWidgetStaticSchema,
  Embed: EmbedWidgetStaticSchema,
  EvaluatablePlugin: EvaluatablePluginWidgetStaticSchema,
  EnclosureWithBlockTitle: EnclosureWithBlockTitleWidgetStaticSchema,
  EnclosureWithCombinedTitle: EnclosureWithCombinedTitleWidgetStaticSchema,
  FillInTheBlanksQuestion: FillInTheBlanksQuestionWidgetStaticSchema,
  FlexSection: FlexSectionWidgetStaticSchema,
  Geogebra: GeogebraWidgetStaticSchema,
  GeogebraQuestion: GeogebraQuestionWidgetStaticSchema,
  Hotspot: HotspotWidgetStaticSchema,
  HotspotQuestion: HotspotQuestionWidgetStaticSchema,
  Image: ImageWidgetStaticSchema,
  InteractivePoll: InteractivePollWidgetStaticSchema,
  InteractiveQuiz: InteractiveQuizWidgetStaticSchema,
  InteractiveVideo: InteractiveVideoWidgetStaticSchema,
  MicrosoftEmbed: MicrosoftEmbedWidgetStaticSchema,
  OpenDiscussion: OpenDiscussionWidgetStaticSchema,
  OpenQuestion: OpenQuestionWidgetStaticSchema,
  Page: PageWidgetStaticSchema,
  PdfDocument: PdfDocumentWidgetStaticSchema,
  Plugin: PluginWidgetStaticSchema,
  QuestionGroupList: QuestionGroupListWidgetStaticSchema,
  Section: SectionWidgetStaticSchema,
  SelectionQuestion: SelectionQuestionWidgetStaticSchema,
  Slide: SlideWidgetStaticSchema,
  SortQuestion: SortQuestionWidgetStaticSchema,
  Spacer: SpacerWidgetStaticSchema,
  StyledBulletList: StyledBulletListWidgetStaticSchema,
  Table: TableWidgetStaticSchema,
  Text: TextWidgetStaticSchema,
  UnifiedVideo: UnifiedVideoStaticSchema,
  Video: VideoWidgetStaticSchema,
  YesNoQuestion: YesNoQuestionWidgetStaticSchema
} satisfies Record<WidgetType, z.ZodTypeAny>;

type StaticSchemas = typeof staticSchemas;
export type StaticSchemasKey = keyof StaticSchemas;

export type WidgetStaticSchemas = {
  [K in StaticSchemasKey]: z.infer<StaticSchemas[K]>;
};
